import type { ICountPillProps } from './ICountPillProps';
import { RecordIcon } from './RecordIcon';

/**
 * Пігулка «іконка лічильник | … | +» (прототип v4): спільна рамка --line2 радіус 10; лічильник відкриває вкладку, «+» — акцентом 700
 * (зв'язати, написати коментар, прикріпити файли); частини розділено лінією --line.
 */
export function CountPill({ glyph, count, group, openLabel, onOpen, middle, addLabel, onAdd, add, canAdd = true, addHint }: ICountPillProps) {
  return (
    <div className="rec-pill" role="group" aria-label={group} title={group}>
      <button type="button" className="rec-pill__open" title={openLabel} aria-label={openLabel} onClick={onOpen}>
        <RecordIcon name={glyph} size={15} />{count}
      </button>
      {middle}
      {addHint && <button type="button" className="rec-pill__add" title={addHint} aria-label={addLabel} disabled>+</button>}
      {canAdd && !addHint && (add ?? <button type="button" className="rec-pill__add" title={addLabel} aria-label={addLabel} onClick={onAdd}>+</button>)}
    </div>
  );
}
